export default __webpack_public_path__ + "static/media/personAdd.5d7a84f5.svg";